import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FiEdit, FiTrash } from 'react-icons/fi';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { AiOutlineCloseCircle } from 'react-icons/ai';


import Layout from '../../components/Layout';
import { Container, List } from './styles';
import Table from '../../components/Table';
import Pagination from '../../components/Pagination';

import api from '../../services/api';

import { Miscellanies as MiscellaniesProps } from '../../interfaces/Miscellanies';
import { confirmAlert } from 'react-confirm-alert';
import { useToast } from '../../hooks/Toast';

const Miscellaneous: React.FC = () => {
  const [data, setData] = useState<MiscellaniesProps[]>([]);
  const [filteredAttr, setFilteredAttr] = useState('');
  const [loadingData, setLoadingData] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [refresh, setRefresh] = useState(false);

  const history = useHistory();
  const { addToast } = useToast();

  useEffect(() => {
    setLoadingData(true);
    api
      .get('miscellanies', {
        params: {
          search: filteredAttr,
          page: currentPage,
        },
      })
      .then(response => {
        setData(response.data.items);
        setLoadingData(false);
        setTotalPages(response.data.last_page);
      });
  }, [filteredAttr, currentPage, refresh]);

  const handleEdit = useCallback(
    user => {
      history.push(`${process.env.PUBLIC_URL}/produtos/miscelaneas/${user.id}`);
    },
    [history],
  );

  let timeout: any;
  const handleSearchInput = useCallback((value) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setFilteredAttr(value);
    }, 1000);
  }, [timeout]);

  const handleDelete = (item: MiscellaniesProps) => {
    try {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui">
              <h1>Confirmação</h1>
              <p>Gostaria de deletar {item.description}? (Está ação irreversível)</p>
              <button onClick={onClose}>Não</button>
              <button
                onClick={async () => {
                  await api.delete(
                    `miscellanies/${item.id}`
                  );

                  addToast({
                    type: 'success',
                    title: 'Item deletado com sucesso!',
                  });
                  setRefresh(!refresh);

                  onClose();
                }}
              >
                Sim, deletar!
              </button>
            </div>
          );
        },
      });
    } catch (err) {
      console.error('err', err);
      addToast({
        type: 'error',
        title: 'Falha na requisição',
        description:
          'Ocorreu um erro ao deletar os dados, atualize a página e tente novamente.',
      });
    }
  };

  return (
    <Layout>
      <Container>
        <div className="breadcrumb">
          <h1>MDS &gt; Produtos &gt; Miscelâneas</h1>


        </div>

        <List>
          <Table>
            <div className="top">
              <div className="filter">
                <input
                  type="text"
                  name="search"
                  placeholder="Pesquisar por nome"
                  onChange={event => handleSearchInput(event.target.value)}
                  className="filter-input"
                />
              </div>
              <button
                type="button"
                className="new-btn"
                onClick={() =>
                  history.push(`${process.env.PUBLIC_URL}/produtos/miscelaneas/novo`)
                }
              >
                Novo
              </button>
            </div>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Custo</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingData ? (
                    <tr>
                      <td colSpan={3}>
                        Carregando equipamentos...
                      </td>
                    </tr>
                  ) : (
                    <>
                      {
                        data.length > 0 ?
                          data.map(item => (
                            <tr key={item.id.toString()}>
                              <td>{item.description}</td>
                              <td>{item.cost.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}</td>
                              <td>
                                <button
                                  type="button"
                                  onClick={() => handleEdit(item)}
                                >
                                  <FiEdit />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleDelete(item)}
                                  title="Deletar"
                                >
                                  <FiTrash size={22} />
                                </button>
                              </td>
                            </tr>
                          )) : (
                            <tr>
                              <td colSpan={3}>
                                Nenhum resultado encontrado
                              </td>
                            </tr>
                          )
                      }
                    </>
                  )}
                </tbody>
              </table>
              <Pagination
                pages={totalPages}
                currentPage={currentPage}
                setPage={p => setCurrentPage(p)}
              />
            </div>
          </Table>
        </List>


      </Container>
    </Layout>
  );
};

export default Miscellaneous;
